import BackCoachIcon from "./BackCoachIcon.js";

/**
 * The mark on its tile.
 *
 * The brand guidelines are explicit: "Below 32px the mark always sits on a tile,
 * never bare. 32px is the smallest tile." Every appearance in this app is
 * between 11 and 22px, so every one of them needs the tile.
 *
 * The tile carries the reversed lockup, which the guidelines define as paper on
 * deep petrol with the clay dot kept: `mark-light.svg` is #F2F0EB with a #C4522A
 * dot, and "recolouring the dot" is listed under Never with only the all-white
 * lockup exempted.
 *
 * `size` is the tile, not the mark. The mark sits at roughly 62% of it, which is
 * the proportion in the system's own app-tile artwork.
 */
export default function BackCoachTile({
  size = 32,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`bc-tile ${className}`.trim()}
      style={{ width: size, height: size, borderRadius: Math.max(3, size * 0.14) }}
      aria-hidden
    >
      <BackCoachIcon size={Math.round(size * 0.62)} />
    </span>
  );
}
